import React from 'react'
import { Link } from 'react-router-dom'
import TabContent from './TabComponent'

function BicycleDetail() {
  return (
    <div>
    <div className="subheader normal-bg section-padding">
      <div className="container">
        <div className="row">
          <div className="col-12 text-left">
            <h1 className="text-custom-white">Bicycle Detail</h1>
            <ul className="custom-flex">
              <li className="fw-500"> <Link to="/" className="text-custom-white">Home</Link> </li>
              <li className="fw-500"> <Link to="/cars" className="text-custom-white">Cars</Link> </li>
              <li className="active fw-500"> Bicycle Detail </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    {/* <!-- End Subheader --> 
    <!-- Start Listing detail --> */}
    <section className="section-padding bg-light-white listing-details">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="listing-details-inner  bg-custom-white padding-20">
              <div className="row">
                <div className="col-lg-8">
                  <div className="detail-slider-for mb-xl-20 magnific-gallery">
                    <div className="slide-item"> <Link to="/bicycle" className="popup"> <img src="/tm/react/bycycle/assets/images/slider-2.jpg" className="image-fit" alt="img"/> </Link> </div>
                  </div>
                  <hr/>
                  <div className="listing-meta-sec mb-md-80">
                  <TabContent/>
                  </div>
                  <div className="row">
                    <div className="col-12">
                      <div className="blog-details bg-custom-white">
                        <hr/>
                        <div className="post-details-tags-social mb-xl-20">
                          <div className="row no-margin">
                            <div className="col-md-6">
                              <div className="tags-box"> <span className="fs-18 text-light-dark"><i className="fas fa-tags"></i></span>
                                <div className="tags"> <Link to="#">Travel</Link> <Link to="#">Tour</Link> <Link to="#">Agent</Link> </div>
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="social-media-box">
                                <ul className="custom-flex">
                                  <li> <Link to="#" className="fb"> <i className="fab fa-facebook-f"></i> </Link> <span className="social-number bg-light-white">500</span> </li>
                                  <li> <Link to="#" className="tw"> <i className="fa-brands fa-x-twitter"></i> </Link> <span className="social-number bg-light-white">20</span> </li>
                                  <li> <Link to="#" className="fb"> <i className="fab fa-youtube"></i> </Link> <span className="social-number bg-light-white">46</span> </li>
                                  <li> <Link to="#" className="bg-custom-blue"> <i className="fas fa-share-alt"></i> </Link> </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                        {/* <!-- tags & social --> 
                        <!-- post author --> */}
                        <div className="post-author bg-light-white padding-15 mb-xl-20">
                          <div className="author-img animate-img mb-sm-20"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/blog/author-img.png" className="image-fit" alt="author-img"/> </Link> </div>
                          <div className="author-caption">
                            <h5 className="fw-600"><Link to="#" className="text-custom-black">Anna Wright</Link> <span className="text-custom-blue fs-16 ml-2"><i className="fa-brands fa-x-twitter"></i></span></h5>
                            <Link to="#" className="authorpost text-custom-blue fw-600">Most article by this author</Link>
                            <p className="text-light-white">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                          </div>
                        </div>
                        {/* <!-- post author --> 
                        <!-- post pagination --> */}
                        <div className="pagination-btn">
                          <nav>
                            <ul className="pagination">
                              <li className="page-item"><Link className="page-link" to="#">Previous</Link></li>
                              <li className="page-item"><Link className="page-link" to="#">Next</Link></li>
                            </ul>
                          </nav>
                        </div>
                        {/* <!-- post pagination --> 
                        <!-- comments --> */}
                        <div className="comment-box section-padding-top p-relative">
                          <div id="comment-box">
                            <h4 className="text-custom-black fw-600">Reviews [4]</h4>
                            <ul className="comments custom">
                              <li className="comment">
                                <article>
                                  <div className="comment-avatar"> <img src="/tm/react/bycycle/assets/images/blog/comment_1.jpg" className="rounded-circle" alt="comment"/> </div>
                                  <div className="comment-content">
                                    <div className="comment-meta">
                                      <div className="comment-meta-header">
                                        <h5 className="text-custom-black fw-600 author mb-3">Rosalina Pong</h5>
                                        <div className="post-date"> <Link to="/blog-details" className="date bg-custom-blue text-custom-white">25 Jan 2024</Link> </div>
                                      </div>
                                      <div className="comment-meta-reply"> <Link to="#" className="comment-reply-link btn-first btn-submit"><i className="fas fa-reply"></i></Link> </div>
                                    </div>
                                    <div className="comment">
                                      <p className="text-light-dark">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    </div>
                                  </div>
                                </article>
                              </li>
                              <li className="comment">
                                <article>
                                  <div className="comment-avatar"> <img src="/tm/react/bycycle/assets/images/blog/comment_2.jpg" className="rounded-circle" alt="comment"/> </div>
                                  <div className="comment-content">
                                    <div className="comment-meta">
                                      <div className="comment-meta-header">
                                        <h5 className="text-custom-black fw-600 author mb-3">Brian Wright</h5>
                                        <div className="post-date"> <Link to="/blog-details" className="date bg-custom-blue text-custom-white">30 Jan 2024</Link> </div>
                                      </div>
                                      <div className="comment-meta-reply"> <Link to="#" className="comment-reply-link btn-first btn-submit"><i className="fas fa-reply"></i></Link> </div>
                                    </div>
                                    <div className="comment">
                                      <p className="text-light-dark">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                    </div>
                                  </div>
                                </article>
                                <ul className="children">
                                  <li className="comment">
                                    <article>
                                      <div className="comment-avatar"> <img src="/tm/react/bycycle/assets/images/blog/comment_3.jpg" className="rounded-circle" alt="comment"/> </div>
                                      <div className="comment-content">
                                        <div className="comment-meta">
                                          <div className="comment-meta-header">
                                            <h5 className="text-custom-black fw-600 author mb-3">Sarah Wright</h5>
                                            <div className="post-date"> <Link to="/blog-details" className="date bg-custom-blue text-custom-white">30 Jan 2024</Link> </div>
                                          </div>
                                          <div className="comment-meta-reply"> <Link to="#" className="comment-reply-link btn-first btn-submit"><i className="fas fa-reply"></i></Link> </div>
                                        </div>
                                        <div className="comment">
                                          <p className="text-light-dark">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
                                        </div>
                                      </div>
                                    </article>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                            <div className="comment-respond" id="respond">
                              <h4 className="text-custom-black fw-600">Leave Comment</h4>
                              <form>
                                <div className="row">
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="text-custom-black fw-500 fs-14">Full Name</label>
                                      <input type="text" name="#" className="form-control form-control-custom" placeholder="Full Name"/>
                                    </div>
                                  </div>
                                  <div className="col-md-6">
                                    <div className="form-group">
                                      <label className="text-custom-black fw-500 fs-14">Email I'd</label>
                                      <input type="email" name="#" className="form-control form-control-custom" placeholder="Email I'd"/>
                                    </div>
                                  </div>
                                  <div className="col-12">
                                    <div className="form-group">
                                      <label className="text-custom-black fw-500 fs-14">Comment</label>
                                      <textarea rows="4" name="#" className="form-control form-control-custom" placeholder="Comment"></textarea>
                                    </div>
                                    <button type="submit" className="btn-first btn-submit">Leave Comment</button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="row">
                    <div className="col-12">
                      <div className="quick-quote bx-wrapper padding-20 mb-xl-30">
                        <h5 className="text-custom-black">Enquiry Now</h5>
                        <form>
                          <div className="row">
                            <div className="col-12">
                              <div className="form-group">
                                <label className="fs-14 text-custom-black fw-500">Pick Up</label>
                                <input type="text" name="#" className="form-control form-control-custom" placeholder="city, distirct or specific airpot"/>
                              </div>
                              <div className="form-group">
                                <label className="fs-14 text-custom-black fw-500">Pick Up Date/Time</label>
                                <div className="input-group group-form">
                                  <input type="text" name="#" className="form-control form-control-custom datepickr" placeholder="mm/dd/yy" readOnly=""/>
                                  <span className="input-group-append"> <i className="far fa-calendar"></i> </span> </div>
                              </div>
                              <div className="form-group">
                                <label className="fs-14 text-custom-black fw-500">Drop Off</label>
                                <input type="text" name="#" className="form-control form-control-custom" placeholder="city, distirct or specific airpot"/>
                              </div>
                              <div className="form-group">
                                <label className="fs-14 text-custom-black fw-500">Drop Off Date/Time</label>
                                <div className="input-group group-form">
                                  <input type="text" name="#" className="form-control form-control-custom datepickr" placeholder="mm/dd/yy" readOnly=""/>
                                  <span className="input-group-append"> <i className="far fa-calendar"></i> </span> </div>
                              </div>
                              <div className="form-group">
                                <label className="fs-14 text-custom-black fw-500">Car Type</label>
                                <div className="group-form">
                                  <select className="custom-select form-control form-control-custom">
                                    <option>Economy</option>
                                    <option>Compact</option>
                                  </select>
                                </div>
                              </div>
                              <button type="submit" className="btn-first btn-submit full-width btn-height">Submit</button>
                            </div>
                          </div>
                        </form>
                      </div>
                      <div className="bicycle-grid mb-xl-30">
                        <div className="bicycle-grid-wrapper bx-wrapper">
                          <div className="image-sec animate-img"> <Link to="#"> <img src="/tm/react/bycycle/assets/images/bicycle/cy-2.jpg" className="full-width" alt="img"/> </Link> </div>
                          <div className="bicycle-grid-caption padding-20 bg-custom-white p-relative">
                            <h4 className="title fs-16"><Link to="#" className="text-custom-black">Economy<small className="text-light-dark">Per Day</small></Link></h4>
                            <span className="price"><small>From</small>$58</span>
                            <div className="action"> <Link className="btn-second btn-small" to="#">View</Link> <Link className="btn-first btn-submit" to="#">Book</Link> </div>
                          </div>
                        </div>
                      </div>
                      <div className="need-help bx-wrapper padding-20">
                        <h5 className="text-custom-black">Need Help?.</h5>
                        <p className="text-light-dark">We would be more than happy to help you. Our team advisor are 24/7 at your service to help you.</p>
                        <ul className="custom">
                          <li className="text-custom-blue fs-18"> <i className="fas fa-phone-alt"></i> <Link to="#" className="text-light-dark">(+347) 123 456 7890</Link> </li>
                          <li className="text-custom-blue fs-18"> <i className="fas fa-envelope"></i> <Link to="#" className="text-light-dark fs-14">help@domain.com</Link> </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    </div>
  )
}

export default BicycleDetail